// Declare action that used in redux
export const UPDATE_NAVIGATION = "UPDATE_NAVIGATION";
export const UPDATE_CART = "UPDATE_CART";
export const ADD_TO_CART = 'ADD_TO_CART';
export const PROFILE_DATA = 'PROFILE_DATA';